module.exports = __webpack_public_path__ + "static/regionsdot-d96a9953db524641b9914c1df35ff799.png";